import styled from "styled-components";

import { responsiveFixedWidth } from "../styles/media";

export const ResetPasswordStyles = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${({ theme }) => theme.colors.semantic.background.gray};

  .card {
    ${responsiveFixedWidth(400)}
  }
`;
